import { updateAndExposeDynamicHeightData } from '../Utils/utils';

// eslint-disable-next-line import/prefer-default-export
export const setWidgetHeightOverrides = (overrides) => {
  const currentOverrides =
    window?.__private__?.dynamicWidgetHeightData?.widgetHeightOverrides || {};

  updateAndExposeDynamicHeightData({
    widgetHeightOverrides: {
      ...currentOverrides,
      ...overrides,
    },
  });
};
